import { type DataForParent, microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { callbacksFromOrdersMicroFrontIframe } from '../../contexts/orders/callbacksFromOrdersMicroFrontIframe'
import { PAGE_TYPE } from '../page-types'
import { useRouter } from 'vue-router'

/* ------- MICROFRONT - MON COMPTE ------- */

export const accountRoutes = [
  {
    path: '/account',
    name: 'account',
    redirect: { name: 'user' },
  },
  {
    path: '/account/menu',
    name: 'user-menu',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => ({
      microFrontName: 'my-account',
      viewName: 'menu',
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/user',
    name: 'user',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'user',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/technical-sales',
    name: 'techsales',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'techsales',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/my-shopping-lists',
    name: 'purchase-orders',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'purchase-orders',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/change-partner',
    name: 'switch-profile',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'switch-profile',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/orders',
    name: 'orders-agri',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'orders-agri',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/order/:orderId',
    name: 'order-detail-agri',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: (route) => {
      return {
        microFrontName: 'my-account',
        viewName: 'order-detail',
        orderId: route.params.orderId,
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
        callbackForMessages: (data: DataForParent) => callbacksFromOrdersMicroFrontIframe(data),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/profile',
    name: 'profile',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'profile',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/associated-accounts',
    name: 'client-associated-accounts',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'client-associated-accounts',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/contract',
    name: 'sales-agreement',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'sales-agreement',
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/shopping-list/:purchaseOrderId',
    name: 'purchase-order-details',
    component: () => import('@b2ag/micro-front-shopping-list/app'),
    props: (props) => ({
      microFrontName: 'shopping-list',
      viewName: 'purchase-order-details',
      purchaseOrderId: props.params.purchaseOrderId,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
    },
  },
]
